import { Typography, makeStyles } from "@material-ui/core";

import React from "react";
import { get } from "lodash";

const useStyles = makeStyles((theme) => ({
  ok: {
    color: theme.palette.success.main,
  },
  low: {
    color: theme.palette.warning.main,
  },
  high: {
    color: theme.palette.error.main,
  },
}));
const MonthsField = ({ record, source, basePath, sortBy, ...props }) => {
  const classes = useStyles();
  const status = get(record, `${source}_status`);
  return (
    <Typography
      {...props}
      className={classes[status]}
      style={{ fontWeight: record?.id === 0 ? "bold" : "normal" }}
    >
      {get(record, source, 0)}
    </Typography>
  );
};
export default MonthsField;
